/* import __COLOCATED_TEMPLATE__ from './card-list.hbs'; */
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
export default class SiteBillingCardList extends Component {}
